import { ThemeUIStyleObject } from 'theme-ui';

export const text: ThemeUIStyleObject = {
  textAlign: 'center',
};
